import React from 'react';
// import sprite from '../icons/symbol/svg/sprite.symbol.svg';
// let selectedFloor = require('../../icons/svg/nrg-stagwell.svg');
// import logo from '../icons/svg/nrg-stagwell.svg';

export default class NrgComponent extends React.Component {

  constructor(props) {
    super(props);

    this.pageNames = [
      'homepage',
      'services',
      'expertise',
      'people',
      'network',
      'news'
    ];

    // Enable browser-only things such as $ without breaking the server-side compile.
    if (typeof(window) === 'undefined') {
      global.$ = function(){};
    }
  }

  /**
   * Generates the `<use>` tag required for our SVG icons.
   * This output is intended for use with `dangerouslySetInnerHTML`
   */
  getSvgUseTag(iconName) {
    var html = `<use href="${iconName}"></use>`;

    return { __html: html };
  }

  getNextPageSlug(currentPage) {
    const currentPageIndex = this.pageNames.indexOf(currentPage);

    return this.pageNames[currentPageIndex+1];
  }

  getPreviousPageSlug(currentPage) {
    const currentPageIndex = this.pageNames.indexOf(currentPage);

    return this.pageNames[currentPageIndex-1];
  }
};
